export default "__VITE_ASSET__DfGJU_RB__"